export const formatPercentage = (percentage: number | string) => {
  return Number(percentage).toFixed(2)
}

export const formatNumber = (number: number | string) => {
  return new Intl.NumberFormat('en-US').format(Number(number || 0))
}
